"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminMGTProvider = exports.useAdminMGTContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const react_dom_1 = require("react-dom");
const ArrayCalculationsFacade_1 = require("src/hello_assets/src/util/ArrayCalculationsFacade");
const ActorsProvider_1 = require("src/hello_assets/src/components/system/actor/ActorsProvider");
const initialContextValue = {
    validation: { validated: false, valid: false },
    status: (0, DataProviderCommonTypes_1.getInitialDataProviderStateStatus)(),
    error: (0, DataProviderCommonTypes_1.getInitialDataProviderStateError)(),
    data: undefined,
    checkHasAccess: () => undefined,
    getInformation: () => undefined,
    getCanisterMetrics: () => undefined,
};
const AdminMGTContext = React.createContext(initialContextValue);
const useAdminMGTContext = () => React.useContext(AdminMGTContext);
exports.useAdminMGTContext = useAdminMGTContext;
const AdminMGTProvider = (props) => {
    const actorsContext = (0, ActorsProvider_1.useActorsContext)();
    const isMounted = (0, isMounted_1.default)();
    const checkHasAccess = (0, react_1.useCallback)(async () => {
        const get = async () => {
            try {
                const controlCenterActor = await actorsContext.getControlCenterActor();
                if (controlCenterActor) {
                    const result = await controlCenterActor.mgt_hasAccess();
                    updateValidationStatus({ validated: true, valid: result });
                }
            }
            catch (e) {
                console.warn("adminMGT_hasAccess failed", e);
                updateValidationStatus({ validated: true, valid: false });
            }
        };
        // noinspection ES6MissingAwait
        get();
    }, [isMounted, actorsContext.getControlCenterActor]);
    const getCanisterMetrics = (0, react_1.useCallback)(async () => {
        const get = async () => {
        };
        // noinspection ES6MissingAwait
        get();
    }, [isMounted]);
    const getInformation = (0, react_1.useCallback)(async (metricsName) => {
        const get = async () => {
            updateContextStatus({ inProgress: true });
            try {
                const controlCenterActor = await actorsContext.getControlCenterActor();
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("AdminMGTProvider.getInformation!", metricsName, controlCenterActor);
                }
                if (controlCenterActor) {
                    let result = await controlCenterActor.mgt_getInformation(metricsName ? [metricsName] : []);
                    // if (process.env.NODE_ENV === "development") {
                    //     result = '{"management": { "projectsTotal": 4, "projectsParticipants": 2}, "analyticsStore": { "projectsWithUsers": 2, "participantsTotal": 5, "newParticipants": [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0], "allClients": 6, "allClientsDAU": [2,0,0,0,0,1,1,1,1,1,0,0,0,1,1,1,2,0,0,1,1,0,0,1,0,0,0,1,1,1]}, "clientRegistry": [{ "clientRegistry_variableA ": 1, "clientRegistry_variableB": [2, 3, 4] },{ "clientRegistry_variableA ": 1, "clientRegistry_variableB": [2, 3, 4] }]}'
                    // }
                    if (!!process.env.IS_TEST_SERVER) {
                        console.log("adminMGT_getInformation: response", result);
                    }
                    if (isMounted()) {
                        try {
                            const resultParsed = JSON.parse(result);
                            // if (process.env.NODE_ENV === "development") {
                            //     resultParsed.management.projects = "|155|CryptoBosco||267|Content Fly||76|chebdenis||61|12||106|test||193|Hello||45|Bitcoin||17|Тест3||113|10||117|DSCVR||268|Content Fly Dev||161|NuancePROD||36|Kailina||33|TestProject||190|w||6|||65|icp||1|Usergeek Management||270|test||26|TestProject||175|Binance Coin||16|179038||131|test||201|test||57|aaa||133|lws||235|ZQ||166|test1||186|ICPets||13|Ku-ku||180|Mod||21|reversi||243|1||29|test2||100|vip||258|VRSTL||84|Test||247|Test1||56|DSocial||7|||223|Atlas Coins||184|tori||202|Onur ||119|f5555||260|James Galvin||102|a||114|pyd||43|One||246|verify||66|test||18|Matrix||83|Images||250|Magnetic||269|Kontribute||224|a||256|dimatest1||219|test||173|LUKSO||69|tets||143|First Project||151|Demo project||189|sample||137|test||4|||12|||48|Dfinity||221|Distrikt ||95|Analytics||232|Blockchain Test||75|Dron||8|Project 3||10|||23|y||165|testing ||179|NFID||109|Peoley||15|🥳 my project тест <select/>😀||132|GOEN||139|ddd||195|kk||205|OG||27|TestProject||54|IC Pioneers||239|Avatar||187|Lewis||259|Catalyze Frontend||110|LydiaLei||218|test||192|icpleague||37|Test||273|whale||178|Airdrop||49|Izakaya||90|tianzhen||138|ICPSwap||158|test_project||271|test2||152|test project||144|blog||265|nuance||46|Motoko||89|3333333333||157|Sample_Solstice||237|Zaratrusta||167|icpgreat||199|aaa||59|tt||272|Nftanvil||40|icp||130|test||162|K2||253|test||50|test||25|Dima project||62|test||73|Avocado||80|VideoList||22|y||261|test01||85|Warrior||212|Tesr||206|New||227|1||211|test||38|Test distrikt||71|Test||228|demo||64|testing||9|||112|1||153|ZH||197|HelloWorld||67|Tnr||55|Sami||39|Ray||87|GOEN||74|Vasilii||194|Aditya||203|motoko||213|test||52|123qq||125|ky||96|ICEvent||127|test||98|icApps||104|Doo||262|test||121|Mr3H_Airdrop||174|Kaplan||44|motoko||19|DSCVR||182|modclub||146|A||147|ICPBunny||92|IC Projects||225|Atlas Coins - Dev||231|watcher||150|Testpeoject||41|OpenChat||176|Kap||116|CR7||214|LV-Research||134|1234||34|test1||170|ICNaming||135|tangling||215|LVResearch||5|||188|NFID DEV||238|test||31|TestProject||88|jngc||3|||47|test||185|Pim||53|IC||101|test||128|Nullex||163|Test||120|ddd||149|Nuance||154|dmitry_test||126|aa||245|test||251|Itoka||207|bla||108|Pyz||254|project1||183|modclub_dev||160|Mrblack||141|hXr.space||97|Distrikt||164|test||93|rapjesus||229|Portfolio||257|dimatest2||171|IC Pets||172|540||111|x||210|world||209|Test||129|Block32||94|test||217|test||11|||86|test||266|kc||248|Project 1||136|test||63|Q||2|||148|dmitry_test||115|x||99|pu||208|Bevis jiang||124|demo||14|test3||159|test||122|mina||220|myfirst||241|STEPN||79|MyBlog||140|MindBank||156|Cosmicrafts||60|vinci||72|Vel||35|Uui||123|Aaa||234|Tag||20|chengwu||177|Canistergeek Online Demo||24|yjjaja||230|Test||240|test||244|a||200|Mybestcryptos||82|Noire||252|mm||28|test1||181|modclub||51|IC||32|TestProject||77|123||118|test||255|project2||58|Tot nano||78|Ygg||222|peter||263|pirosiki||196|nafla||81|Binz Nguyen||264|pod||233|p1||68|DSocial Test by Alexey||226|mr j t ball||107|Longxia community||204|DYOR||191|Verified Giveaways||142|test||105|test||236|test1||249|Catalyze||70|Vishal||216|iclions||242|Deen||42|CIPOTO||91|Melli||103|swap||198|test1||30|testproject||145|arapon||169|ыфывф||168|test|"
                            //     resultParsed.analyticsStore.projectUsers = [["269","+231"],["267","+13"],["256","+4"],["180","+1"],["156","+2"],["257","+1"],["188","+1"],["268","+4"],["68","+1"],["161","+630"],["56","+3_957"],["223","+3"],["1","+346"],["149","+136"],["179","+296"],["19","+57_680"],["182","+1_524"],["225","+1"],["254","+1"],["183","+144"],["41","+13_156"]]
                            // }
                            const processAnalyticsStore = (store) => {
                                store.newParticipantsCumulative = ArrayCalculationsFacade_1.ArrayCalculationsFacade.cumulative(store.newParticipants);
                                //now we need to get last cumulative value, subtract it from participantsTotal and add this number to all cumulative array values
                                const lastCumulativeValue = lodash_1.default.last(store.newParticipantsCumulative) || 0;
                                const numberToAddToCumulativeArrayValues = store.participantsTotal - lastCumulativeValue;
                                store.newParticipantsCumulative = ArrayCalculationsFacade_1.ArrayCalculationsFacade.add(store.newParticipantsCumulative, numberToAddToCumulativeArrayValues);
                            };
                            processAnalyticsStore(resultParsed.analyticsStore);
                            processAnalyticsStore(resultParsed.analyticsStore2);
                            resultParsed.analyticsStoreTotal = {
                                allClients: resultParsed.analyticsStore.allClients + resultParsed.analyticsStore2.allClients,
                                allClientsDAU: ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray([
                                    resultParsed.analyticsStore.allClientsDAU,
                                    resultParsed.analyticsStore2.allClientsDAU,
                                ]),
                                newParticipants: ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray([
                                    resultParsed.analyticsStore.newParticipants,
                                    resultParsed.analyticsStore2.newParticipants,
                                ]),
                                newParticipantsCumulative: ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray([
                                    resultParsed.analyticsStore.newParticipantsCumulative,
                                    resultParsed.analyticsStore2.newParticipantsCumulative,
                                ]),
                                participantsTotal: resultParsed.analyticsStore.participantsTotal + resultParsed.analyticsStore2.participantsTotal
                            };
                            if (!!process.env.IS_TEST_SERVER) {
                                console.log("adminMGT_getInformation: response JSON", resultParsed);
                            }
                            (0, react_dom_1.unstable_batchedUpdates)(() => {
                                updateContextStatus({ inProgress: false, loaded: true });
                                updateContextError({ error: undefined, isError: false, });
                                updateContextData({ information: resultParsed });
                            });
                        }
                        catch (e) {
                            console.warn("adminMGT_getInformation failed: parsing error", e);
                            updateContextStatus({ inProgress: false, loaded: true });
                            updateContextError({ error: undefined, isError: false, });
                            updateContextData({ fallback: result });
                        }
                    }
                }
                else {
                    if (isMounted()) {
                        updateContextStatus({ inProgress: false });
                    }
                }
            }
            catch (e) {
                console.warn("adminMGT_getInformation failed: network error", e);
                if (isMounted()) {
                    updateContextStatus({ inProgress: false });
                    updateContextError({ isError: true, error: e, });
                }
            }
        };
        // noinspection ES6MissingAwait
        get();
    }, [isMounted]);
    const [validationStatus, updateValidationStatus] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep(initialContextValue.validation));
    const [contextStatus, updateContextStatus] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep((0, DataProviderCommonTypes_1.getInitialDataProviderStateStatus)()));
    const [contextError, updateContextError] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep((0, DataProviderCommonTypes_1.getInitialDataProviderStateError)()));
    const [contextData, updateContextData] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { information: {} });
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        validation: validationStatus,
        status: contextStatus,
        error: contextError,
        data: contextData,
        checkHasAccess: checkHasAccess,
        getInformation: getInformation,
        getCanisterMetrics: getCanisterMetrics,
    }), [
        validationStatus,
        contextStatus,
        contextError,
        contextData,
        checkHasAccess,
        getInformation,
        getCanisterMetrics,
    ], (prevDeps, nextDeps) => {
        return lodash_1.default.isEqual(prevDeps, nextDeps);
    });
    return React.createElement(AdminMGTContext.Provider, { value: value }, props.children);
};
exports.AdminMGTProvider = AdminMGTProvider;
